import React from 'react';
import { Card } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import './ContactForm.css';

class ContactForm extends React.Component {
  state = {
    status: ''
  }

  render() {
    const { status } = this.state;
    return (
      <div id = "contact">
      <Card id = "formCard">
        <form
          onSubmit={this.submitForm}
          action="https://formspree.io/mbjkewkv"
          method="POST"
          id='form'
        >
          <h5 id="cardTitle">Submit a Helpful Resource</h5>
          <input className = "inputBox" type="text" autoComplete="off" placeholder="URL" name="url" />
          <input className = "inputBox" type="text" autoComplete="off" placeholder="Title" name="title" />
          <input className = "inputBox" type="text" autoComplete="off" placeholder="Description" name="description"/>
          {status === "SUCCESS" ? <p id="confirmation">Thank You! Your resource will be reviewed.</p> : <button id = "formButton">Contribute</button>}
          {status === "ERROR" && <p>Ooops! There was an error.</p>}
        </form>
      </Card>
      </div>
    );
  }

  submitForm = (ev) => {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}

export default ContactForm;